import { TStoreState } from 'redux/types';
import { createSelector } from '@reduxjs/toolkit';
import {
	TCountryVatRateListRequest,
	TCountryVatRateListResponse,
	TCustomsDutyRateListResponse,
	TSpecialTerritoryListRequest,
	TSpecialTerritoryListResponse,
	TSpecialTerritoryPostalCodeListRequest,
	TSpecialTerritoryPostalCodeListResponse,
	THs6pCodeListResponse,
	TSupportedNonEuCountry,
	TTaxDutiesStore,
} from './types';

export const getTaxDutiesState = (state: TStoreState): TTaxDutiesStore => state.taxDuties;

export const getCountryVatRateList = createSelector(
	[getTaxDutiesState],
	(taxDuties: TTaxDutiesStore): TCountryVatRateListResponse | null => taxDuties.countryVatRateList,
);

export const getCountryVatRateLastListParams = createSelector(
	[getTaxDutiesState],
	(taxDuties: TTaxDutiesStore): TCountryVatRateListRequest | null =>
		taxDuties.countryVatRateLastListParams,
);

export const getCountryVatRateListLoading = createSelector(
	[getTaxDutiesState],
	(taxDuties: TTaxDutiesStore): boolean => taxDuties.countryVatRateListLoading,
);

export const getCountryVatRateSyncLoading = createSelector(
	[getTaxDutiesState],
	(taxDuties: TTaxDutiesStore): boolean => taxDuties.countryVatRateSyncLoading,
);

export const getCountryVatRateUploadLoading = createSelector(
	[getTaxDutiesState],
	(taxDuties: TTaxDutiesStore): boolean => taxDuties.countryVatRateUploadLoading,
);

export const getNonEuCountryVatRateList = createSelector(
	[getTaxDutiesState],
	(taxDuties: TTaxDutiesStore): TCountryVatRateListResponse | null =>
		taxDuties.nonEuCountryVatRateList,
);

export const getNonEuCountryVatRateListLoading = createSelector(
	[getTaxDutiesState],
	(taxDuties: TTaxDutiesStore): boolean => taxDuties.nonEuCountryVatRateListLoading,
);

export const getSupportedNonEuCountryList = createSelector(
	[getTaxDutiesState],
	(taxDuties: TTaxDutiesStore): TSupportedNonEuCountry[] | null =>
		taxDuties.supportedNonEuCountryList,
);

export const getSupportedNonEuCountryListLoading = createSelector(
	[getTaxDutiesState],
	(taxDuties: TTaxDutiesStore): boolean => taxDuties.supportedNonEuCountryListLoading,
);

export const getHs6pCodeList = createSelector(
	[getTaxDutiesState],
	(taxDuties: TTaxDutiesStore): THs6pCodeListResponse | null => taxDuties.hs6pCodeList,
);

export const getHs6pCodeListLoading = createSelector(
	[getTaxDutiesState],
	(taxDuties: TTaxDutiesStore): boolean => taxDuties.hs6pCodeListLoading,
);

export const getCustomsDutyRateList = createSelector(
	[getTaxDutiesState],
	(taxDuties: TTaxDutiesStore): TCustomsDutyRateListResponse | null =>
		taxDuties.customsDutyRateList,
);

export const getCustomsDutyRateListLoading = createSelector(
	[getTaxDutiesState],
	(taxDuties: TTaxDutiesStore): boolean => taxDuties.customsDutyRateListLoading,
);

export const getSpecialTerritoryList = createSelector(
	[getTaxDutiesState],
	(taxDuties: TTaxDutiesStore): TSpecialTerritoryListResponse | null =>
		taxDuties.specialTerritoryList,
);

export const getSpecialTerritoryListLoading = createSelector(
	[getTaxDutiesState],
	(taxDuties: TTaxDutiesStore): boolean => taxDuties.specialTerritoryListLoading,
);

export const getSpecialTerritoryLastListParams = createSelector(
	[getTaxDutiesState],
	(taxDuties: TTaxDutiesStore): TSpecialTerritoryListRequest | null =>
		taxDuties.specialTerritoryLastListParams,
);

export const getSpecialTerritorySaveLoading = createSelector(
	[getTaxDutiesState],
	(taxDuties: TTaxDutiesStore): boolean => taxDuties.specialTerritorySaveLoading,
);

export const getSpecialTerritorySaveSuccess = createSelector(
	[getTaxDutiesState],
	(taxDuties: TTaxDutiesStore): boolean => taxDuties.specialTerritorySaveSuccess,
);

export const getSpecialTerritoryPostalCodeList = createSelector(
	[getTaxDutiesState],
	(taxDuties: TTaxDutiesStore): TSpecialTerritoryPostalCodeListResponse | null =>
		taxDuties.specialTerritoryPostalCodeList,
);

export const getSpecialTerritoryPostalCodeListLoading = createSelector(
	[getTaxDutiesState],
	(taxDuties: TTaxDutiesStore): boolean => taxDuties.specialTerritoryPostalCodeListLoading,
);

export const getSpecialTerritoryPostalCodeLastListParams = createSelector(
	[getTaxDutiesState],
	(taxDuties: TTaxDutiesStore): TSpecialTerritoryPostalCodeListRequest | null =>
		taxDuties.specialTerritoryPostalCodeLastListParams,
);

export const getSpecialTerritoryPostalCodeSaveLoading = createSelector(
	[getTaxDutiesState],
	(taxDuties: TTaxDutiesStore): boolean => taxDuties.specialTerritoryPostalCodeSaveLoading,
);

export const getSpecialTerritoryPostalCodeSaveSuccess = createSelector(
	[getTaxDutiesState],
	(taxDuties: TTaxDutiesStore): boolean => taxDuties.specialTerritoryPostalCodeSaveSuccess,
);
